import type {PropertyDefinitionBase} from '@github-ui/custom-properties-types'
import type {PropsWithChildren} from 'react'
import type React from 'react'

import {getDefinitionLabel} from '../helpers/definition-type-label'
import styles from './DefinitionReadOnlyOverview.module.css'

function DefinitionReadOnlyTable({children}: {children: React.ReactNode}) {
  return (
    <div data-testid="readonly-property-definitions-settings" data-hpc className="border rounded-2">
      <div className="border-bottom text-bold bgColor-inset rounded-top-2 tmp-p-3">Property attributes</div>
      {children}
    </div>
  )
}

function DataRow({label, children}: PropsWithChildren<{label: string}>) {
  return (
    <div className={styles.dataRow}>
      <div className={styles.dataRowTitle}>{label}</div>
      <div className={styles.dataRowValue}>{children}</div>
    </div>
  )
}

function CommonAttributes({definition}: {definition: PropertyDefinitionBase}) {
  return (
    <>
      <DataRow label="Name">{definition.propertyName}</DataRow>
      <DataRow label="Description">{definition.description}</DataRow>
      <DataRow label="Type">{getDefinitionLabel(definition.valueType)}</DataRow>
      {definition.allowedValues && <DataRow label="Options">{definition.allowedValues.join(', ')}</DataRow>}
      {definition.valueType === 'string' && (
        <>
          <DataRow label="Match regular expression">{definition.regex ? 'Enabled' : 'Disabled'}</DataRow>
          {definition.regex && <DataRow label="Expression">{definition.regex}</DataRow>}
        </>
      )}
      <DataRow label="Required">{definition.required ? 'Enabled' : 'Disabled'}</DataRow>
      {definition.defaultValue && (
        <DataRow label="Default value">
          {Array.isArray(definition.defaultValue) ? definition.defaultValue.join(', ') : definition.defaultValue}
        </DataRow>
      )}
    </>
  )
}

export const DefinitionReadOnlyOverview = Object.assign(DefinitionReadOnlyTable, {
  DataRow,
  CommonAttributes,
})
